document.addEventListener("DOMContentLoaded", function () {
  var sliders = document.querySelectorAll('[data-collection-list]');

  sliders.forEach(function (slider) {
    new Flickity(slider, {
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      autoPlay: false,
      draggable: true,
      resize: true
    });
  });
});